import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';
import ConfigProvider from '../config-provider';
var Button =
/*#__PURE__*/
React.forwardRef(function (_a, ref) {
  var _classNames;

  var customizePrefixCls = _a.prefixCls,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'normal' : _a$size,
      _a$htmlType = _a.htmlType,
      htmlType = _a$htmlType === void 0 ? 'button' : _a$htmlType,
      _a$loading = _a.loading,
      loading = _a$loading === void 0 ? false : _a$loading,
      type = _a.type,
      outline = _a.outline,
      dashed = _a.dashed,
      disabled = _a.disabled,
      ghost = _a.ghost,
      circle = _a.circle,
      block = _a.block,
      icon = _a.icon,
      svgIcon = _a.svgIcon,
      href = _a.href,
      className = _a.className,
      children = _a.children,
      onClick = _a.onClick,
      extraProps = __rest(_a, ["prefixCls", "size", "htmlType", "loading", "type", "outline", "dashed", "disabled", "ghost", "circle", "block", "icon", "svgIcon", "href", "className", "children", "onClick"]);

  var _React$useContext = React.useContext(ConfigProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('button', customizePrefixCls);
  var classes = classNames(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "--").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "--").concat(size), size), _defineProperty(_classNames, "".concat(prefixCls, "--outline"), outline), _defineProperty(_classNames, "".concat(prefixCls, "--dashed"), dashed), _defineProperty(_classNames, "".concat(prefixCls, "--ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "--circle"), circle), _defineProperty(_classNames, "".concat(prefixCls, "--block"), block), _defineProperty(_classNames, "underline", href && type === 'link'), _defineProperty(_classNames, "loading", loading), _defineProperty(_classNames, "disabled", disabled), _classNames)); // icon Element

  var iconNode;

  if (loading) {
    iconNode =
    /*#__PURE__*/
    React.createElement(Icon, {
      type: "loading",
      spin: true
    });
  } else if (svgIcon) {
    iconNode =
    /*#__PURE__*/
    React.createElement(Icon, {
      svg: svgIcon
    });
  } else if (icon) {
    iconNode =
    /*#__PURE__*/
    React.createElement(Icon, {
      type: icon
    });
  }

  var handleClick = function handleClick(e) {
    if (loading || disabled) {
      return;
    }

    e.target.blur();

    if (onClick) {
      onClick(e);
    }
  }; // only if children is plain text, wrap it with span


  var childrenNode = typeof children === 'string' ?
  /*#__PURE__*/
  React.createElement("span", null, children) : children;
  return (
    /*#__PURE__*/
    React.createElement("button", _extends({}, extraProps, {
      ref: ref // eslint-disable-next-line react/button-has-type
      ,
      type: htmlType,
      className: classes,
      onClick: handleClick
    }), iconNode, childrenNode)
  );
});
export default Button;